import React from "react";
import {
  Trash2,
  Link as LinkIcon,
  Upload,
  Image as ImageIcon,
  Video as VideoIcon,
  Clock,
  Type,
} from "lucide-react";
import { IMAGE_URL } from "../../../config";

const MediaManager = ({ asset, onUpdate, onDelete }) => {
  const isVideo = asset.type === "video";
  const isUploadType = asset.videoType === "upload";

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    const xhr = new XMLHttpRequest();
    xhr.open("POST", IMAGE_URL);

    xhr.upload.onprogress = (e) => {};

    xhr.onloadstart = () => {};

    xhr.onload = () => {
      if (xhr.status === 200) {
        const response = JSON.parse(xhr.responseText);
        const filePath = response?.data?.filePath;
        const fullUrl = filePath.startsWith("http")
          ? filePath
          : `https://erp.mgreeninnovations.com${filePath}`;

        onUpdate({ url: fullUrl });

        console.log(fullUrl, "Upload success");
      } else {
        console.error("Upload failed", xhr.statusText);
        alert("Image upload failed!");
      }
    };

    xhr.onerror = () => {
      console.error("Error uploading image:", xhr.statusText);
      alert("An error occurred during upload!");
    };

    xhr.send(formData);
  };

  const handleFileUpload = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      // Create a local blob URL for preview/rehydration in this session
      const objectUrl = URL.createObjectURL(file);
      onUpdate({ url: objectUrl });
    }
  };

  return (
    <div className="bg-slate-50 border border-slate-200 rounded-xl p-6 relative group animate-in fade-in zoom-in duration-300">
      <button
        type="button"
        onClick={onDelete}
        className="absolute top-4 right-4 p-2 text-slate-300 hover:text-red-500 bg-white shadow-sm border border-slate-100 rounded-lg transition-all opacity-0 group-hover:opacity-100 z-10"
      >
        <Trash2 size={16} />
      </button>

      <div className="flex items-center gap-3 mb-6">
        <div
          className={`p-2 rounded-lg ${isVideo ? "bg-indigo-100 text-primary" : "bg-blue-100 text-blue-600"}`}
        >
          {isVideo ? <VideoIcon size={20} /> : <ImageIcon size={20} />}
        </div>
        <div>
          <h4 className="text-sm font-bold text-slate-800 capitalize">
            {asset.type} Asset
          </h4>
          <p className="text-[10px] text-slate-400 uppercase tracking-widest font-bold">
            Configuration
          </p>
        </div>
      </div>

      <div className="space-y-4">
        {isVideo && (
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <label className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">
                Video Type
              </label>
              <select
                className="w-full bg-white border border-slate-200 rounded-lg px-3 py-2 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-indigo-500/20"
                value={asset.videoType}
                onChange={(e) => onUpdate({ videoType: e.target.value })}
              >
                <option value="embed">Embed (YouTube/Vimeo)</option>
                <option value="upload">Upload Video File</option>
              </select>
            </div>

            {/* show minutes */}
            {/* {isVideo && isUploadType && ( */}
            <div className="space-y-2">
              <label className="text-[10px] font-bold text-slate-400 uppercase tracking-wider flex items-center gap-1">
                <Clock size={12} /> Minutes
              </label>
              <input
                type="number"
                placeholder="0"
                className="w-full bg-white border border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500/20"
                value={asset.duration || ""}
                onChange={(e) =>
                  onUpdate({
                    duration: parseInt(e.target.value) || 0,
                  })
                }
              />
            </div>
            {/* )} */}
          </div>
        )}

        <div className="space-y-2">
          <label className="text-[10px] font-bold text-slate-400 uppercase tracking-wider flex items-center gap-1">
            <LinkIcon size={12} />{" "}
            {isVideo && !isUploadType ? "Embed Link" : "Source URL / Upload"}
          </label>
          <div className="flex gap-2">
            <input
              type="text"
              placeholder={
                isVideo
                  ? isUploadType
                    ? "Direct video link or upload..."
                    : "Paste YouTube/Vimeo URL..."
                  : "Image URL (JPG, PNG, WebP)..."
              }
              className="flex-1 bg-white border border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500/20"
              value={asset.url}
              onChange={(e) => onUpdate({ url: e.target.value })}
            />
            {(!isVideo || isUploadType) && (
              <label className="flex items-center justify-center bg-white border border-slate-200 rounded-lg px-4 py-2 text-slate-500 cursor-pointer hover:bg-slate-100 hover:text-primary transition-all shadow-sm">
                <Upload size={18} />
                <input
                  type="file"
                  className="hidden"
                  accept={isVideo ? "video/mp4,video/webm" : "image/*"}
                  onChange={(event) => handleFileChange(event)}
                />
              </label>
            )}
          </div>
        </div>

        <div className="space-y-2">
          <label className="text-[10px] font-bold text-slate-400 uppercase tracking-wider flex items-center gap-1">
            Description / Caption
          </label>
          <textarea
            className="w-full bg-white border border-slate-200 rounded-lg px-3 py-2 text-sm min-h-[60px] focus:outline-none focus:ring-2 focus:ring-indigo-500/20"
            placeholder={
              isVideo
                ? "Describe what happens in this video..."
                : "Image caption or context..."
            }
            value={asset.description}
            onChange={(e) => onUpdate({ description: e.target.value })}
          />
        </div>

        {!isVideo && (
          <div className="space-y-2">
            <label className="text-[10px] font-bold text-red-400 uppercase tracking-wider flex items-center gap-1">
              <Type size={12} /> Alt Text (SEO)
            </label>
            <input
              type="text"
              placeholder="Descriptive text for accessibility..."
              className={`w-full bg-white border rounded-lg px-3 py-2 text-sm focus:outline-none transition-colors ${!asset.altText && asset.url ? "border-red-200 bg-red-50/20" : "border-slate-200"}`}
              value={asset.altText || ""}
              onChange={(e) => onUpdate({ altText: e.target.value })}
            />

            <label className="text-[10px] font-bold text-slate-400 uppercase tracking-wider flex items-center gap-1">
              <Type size={12} /> Image Referal Link
            </label>
            <input
              type="text"
              placeholder="Please paste the link of the referred image..."
              className={`w-full bg-white border rounded-lg px-3 py-2 text-sm focus:outline-none transition-colors border-slate-200`}
              value={asset.image_refferal || ""}
              onChange={(e) => onUpdate({ image_refferal: e.target.value })}
            />
            <label className="text-[10px] font-bold text-slate-400 uppercase tracking-wider flex items-center gap-1">
              <Type size={12} /> Property Referral Link
            </label>
            <input
              type="text"
              placeholder="Please paste the link of the property..."
              className={`w-full bg-white border rounded-lg px-3 py-2 text-sm focus:outline-none transition-colors border-slate-200`}
              value={asset.property_refferal || ""}
              onChange={(e) => onUpdate({ property_refferal: e.target.value })}
            />
          </div>
        )}
      </div>

      {/* Media Preview */}
      {asset.url && (
        <div className="mt-6 rounded-xl overflow-hidden border border-slate-200 bg-black/5 shadow-inner">
          {isVideo ? (
            <div className="aspect-video relative group/preview">
              <video
                src={asset.url}
                controls
                className="w-full h-full object-contain bg-black"
                onError={(e) => {
                  // If it's a YouTube/Vimeo link that can't be played via <video>
                  if (
                    asset.url.includes("youtube.com") ||
                    asset.url.includes("vimeo.com")
                  ) {
                    const el = e.currentTarget;
                    el.style.display = "none";
                    const parent = el.parentElement;
                    if (parent && !parent.querySelector(".embed-msg")) {
                      const msg = document.createElement("div");
                      msg.className =
                        "embed-msg absolute inset-0 flex flex-col items-center justify-center text-slate-500 text-xs text-center p-4";
                      msg.innerHTML = `<div class="bg-indigo-100 p-2 rounded-full mb-2"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="5 3 19 12 5 21 5 3"></polygon></svg></div>External Embed Detected<br/>Ready for publication`;
                      parent.appendChild(msg);
                    }
                  }
                }}
              />
            </div>
          ) : (
            <img
              src={asset.url}
              alt={asset.altText}
              className="w-full h-48 object-cover"
            />
          )}
        </div>
      )}
    </div>
  );
};

export default MediaManager;
